import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { crossPageColorContrastIssuesAtom } from '../../atoms/session-atoms';
import { getSpecificPageIssueResults } from './get-specific-page-issue-result';
export const useBuildSpecificPageIssueResults = () => {
  const crossPageColorContrastIssuesInSession = useAtomValue(crossPageColorContrastIssuesAtom);
  return useCallback(_ref => {
    let {
      executionResults,
      crossPageIssues
    } = _ref;
    const specificPageResults = getSpecificPageIssueResults(executionResults, crossPageIssues, crossPageColorContrastIssuesInSession);
    return specificPageResults;
  }, [crossPageColorContrastIssuesInSession]);
};
//# sourceMappingURL=use-build-specific-page-issue-results.js.map